"use client";

import { useEffect } from "react";

/**
 * **La pagina si sposta da sé quando si tocca una notifica** (11-4, secondo
 * tempo). Se l'app è già aperta, `public/sw.js` non la fa navigare — su iPhone
 * «navigate» la riportava davanti lasciandola dov'era — ma le manda un
 * messaggio con l'indirizzo, e lo si apre qui.
 *
 * L'indirizzo si controlla **di nuovo**: solo pagine di questo sito, anche se
 * il service worker l'ha già fatto. Non disegna niente.
 */
export function ApriDallaNotifica() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }
    const contenitore = navigator.serviceWorker;
    function alMessaggio(evento: MessageEvent) {
      const dati: unknown = evento.data;
      if (typeof dati !== "object" || dati === null) {
        return;
      }
      const { tipo, indirizzo } = dati as { tipo?: unknown; indirizzo?: unknown };
      if (tipo !== "apri" || typeof indirizzo !== "string") {
        return;
      }
      try {
        const url = new URL(indirizzo, window.location.origin);
        if (url.origin === window.location.origin) {
          window.location.assign(url.href);
        }
      } catch {
        // Un indirizzo che non si capisce non apre niente.
      }
    }
    contenitore.addEventListener("message", alMessaggio);
    contenitore.startMessages();
    // **Il service worker si aggiorna a ogni apertura.** L'iPhone non lo
    // ricontrolla da solo quando l'app torna davanti: nel collaudo della 11-4
    // una correzione a `public/sw.js` non arrivava al telefono. Il file è
    // servito senza cache (next.config.ts), quindi il controllo costa una
    // richiesta piccola, e un file uguale non cambia niente.
    contenitore
      .getRegistration("/")
      .then((registrazione) => registrazione?.update())
      .catch(() => {
        // Senza rete o senza service worker non c'è niente da aggiornare.
      });
    return () => contenitore.removeEventListener("message", alMessaggio);
  }, []);
  return null;
}
